/* unplugin-vue-components disabled */import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  class: "dialog-content"
};
const _hoisted_2 = {
  class: "header"
};
const _hoisted_3 = {
  class: "header-left"
};
const _hoisted_4 = {
  key: 0,
  t: "1688699821371",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "9139",
  width: "2.5rem",
  height: "2.5rem"
};
const _hoisted_5 = {
  key: 1,
  t: "1688699861340",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "11152",
  width: "2.5rem",
  height: "2.5rem"
};
const _hoisted_6 = {
  class: "header-right"
};
const _hoisted_7 = {
  class: "form"
};
const _hoisted_8 = {
  class: "tables"
};
const _hoisted_9 = {
  class: "table1"
};
const _hoisted_10 = {
  class: "grid1"
};
const _hoisted_11 = {
  class: "row2-item1"
};
const _hoisted_12 = {
  class: "row2-item1-pd1"
};
const _hoisted_13 = {
  class: "lxxn"
};
const _hoisted_14 = {
  class: "xm"
};
const _hoisted_15 = {
  class: "row3"
};
const _hoisted_16 = {
  class: "standard"
};
const _hoisted_17 = {
  class: "table3"
};
const _hoisted_18 = {
  class: "grid3"
};
const _hoisted_19 = {
  class: "row1"
};
const _hoisted_20 = {
  style: {
    "margin-left": "15px"
  }
};
const _hoisted_21 = {
  style: {
    "margin-left": "15px"
  }
};
const _hoisted_22 = {
  class: "row2"
};
const _hoisted_23 = {
  class: "row2-item"
};
const _hoisted_24 = {
  class: "row2-item"
};
const _hoisted_25 = {
  class: "row2-item"
};
const _hoisted_26 = {
  class: "row2-item"
};
const _hoisted_27 = {
  key: 0
};
const _hoisted_28 = {
  class: "table4"
};
const _hoisted_29 = {
  class: "grid4"
};
const _hoisted_30 = {
  class: "row2"
};
const _hoisted_31 = {
  class: "row2-item1"
};
const _hoisted_32 = {
  class: "row2-item1"
};
const _hoisted_33 = {
  class: "row2-item1"
};
const _hoisted_34 = {
  class: "table5"
};
const _hoisted_35 = {
  class: "grid5"
};
const _hoisted_36 = {
  class: "row1-item",
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center"
  }
};
const _hoisted_37 = {
  class: "row1-item"
};
import { newFileDownload, newFileDownload2, queryTeachercomments, queryPhysicalStudentDetailInfo } from "@/api";
import userStore from "@/store/modules/user.js";
import { storeToRefs } from "pinia";
import ConfigTable from "./ConfigTable";
import { API_HOST } from "@/utils/request.js";
export default {
  __name: 'comprehensiveQuality',
  props: ["rowInfo"],
  setup(__props) {
    const user = userStore();
    const {
      userInfo
    } = storeToRefs(user);
    const form = ref({
      schoolYear: String(userInfo.value.schoolYear),
      schoolTerm: String(userInfo.value.schoolTerm)
    });
    const props = __props;
    const schoolYears = inject("schoolYears");
    const schoolTerms = inject("schoolTerms");
    // 报告单数据
    // 综合素养
    const ZHSY = ref({});
    // 学业水平
    // const XYSP = ref([])
    // 身心健康
    const SXJK = ref({});
    const tableGrade = ref({
      selection: false,
      // 头部数据
      tHead: [{
        label: "学科",
        field: "courseName1"
      }, {
        label: "期中考试",
        field: "mid1",
        width: 120
      }, {
        label: "期末考试",
        field: "fin1",
        width: 120
      }, {
        label: "学科",
        field: "courseName2"
      }, {
        label: "期中考试",
        field: "mid2",
        width: 120
      }, {
        label: "期末考试",
        field: "fin2",
        width: 120
      }],
      // 内容
      conBody: []
    });
    // 学生荣誉
    const XSRY = ref([]);
    // 教师寄语
    const JSJY = ref([]);
    function getZHSY() {
      const params = {
        // classCode: "DSZX20200701",
        classCode: props.rowInfo.classCode,
        noDownload: 1,
        // schoolNum: props.rowInfo.classCode,
        schoolNum: props.rowInfo.schoolNum,
        schoolTerm: form.value.schoolTerm,
        schoolYear: form.value.schoolYear,
        userName: props.rowInfo.userName
      };
      newFileDownload(params).then(res => {
        if (res.code === "success") {
          ZHSY.value = res.data.newCa;
          XSRY.value = res.data.re;
          tableGrade.value.conBody = res.data.co;
        }
      });
    }
    getZHSY();
    function getSXJK() {
      const params = {
        schoolNum: props.rowInfo.schoolNum,
        // schoolNum: "HKXDEZX",
        schoolTerm: form.value.schoolTerm,
        schoolYear: form.value.schoolYear,
        userName: props.rowInfo.userName
      };
      queryPhysicalStudentDetailInfo(params).then(res => {
        console.log("then");
        const obj = {
          categoryCode: null,
          categoryName: null,
          levelCode: null,
          value: null,
          level: null
        };
        res.data = res.data ?? {
          physicalCategoryScoreInfoVoList: []
        };
        let lent = (res.data.physicalCategoryScoreInfoVoList.length + 4) % 3;
        if (lent !== 0) {
          if (lent === 1) {
            // console.log("2个")
            res.data.physicalCategoryScoreInfoVoList.push(obj);
            res.data.physicalCategoryScoreInfoVoList.push(obj);
          } else {
            // console.log("1个")
            res.data.physicalCategoryScoreInfoVoList.push(obj);
          }
        }
        SXJK.value = res.data;
      }).catch(() => {
        console.log("catch");
        const obj = {
          categoryCode: null,
          categoryName: null,
          levelCode: null,
          value: null,
          level: null
        };
        const res = {
          data: {
            physicalCategoryScoreInfoVoList: []
          }
        };
        let lent = (res.data.physicalCategoryScoreInfoVoList.length + 4) % 3;
        console.log(lent, "lentlentlent");
        if (lent !== 0) {
          if (lent === 1) {
            // console.log("2个")
            res.data.physicalCategoryScoreInfoVoList.push(obj);
            res.data.physicalCategoryScoreInfoVoList.push(obj);
          } else {
            // console.log("1个")
            res.data.physicalCategoryScoreInfoVoList.push(obj);
          }
        }
        SXJK.value = res.data;
      });
    }
    getSXJK();
    function getJSJY() {
      const params = {
        schoolNum: props.rowInfo.schoolNum,
        // schoolNum: "HKXDEZX",
        schoolYear: form.value.schoolYear,
        schoolTerm: form.value.schoolTerm,
        userName: props.rowInfo.userName
      };
      queryTeachercomments(params).then(res => {
        if (res.code === "success") {
          JSJY.value = res.data;
        }
      });
    }
    getJSJY();
    function changeschoolYear() {
      getZHSY();
      getSXJK();
      getJSJY();
    }
    function changeschoolTerm() {
      getZHSY();
      getSXJK();
      getJSJY();
    }
    function exportDoc() {
      const params = {
        // classCode: "DSZX20200701",
        classCode: props.rowInfo.classCode,
        noDownload: 0,
        // schoolNum: props.rowInfo.classCode,
        schoolNum: props.rowInfo.schoolNum,
        schoolTerm: form.value.schoolTerm,
        schoolYear: form.value.schoolYear,
        userName: props.rowInfo.userName
      };
      newFileDownload2(params).then(res => {
        const link = document.createElement("a");
        const blob = new Blob([res], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
        });
        link.style.display = "none";
        link.href = URL.createObjectURL(blob);
        // download="filename" 属性规定被下载的超链接目标。filename规定作为文件名来使用的文本。
        link.download = `${props.rowInfo.studentName}.docx`; // 下载的文件名
        // link(a)是一个dom元素（一个标签）,向body中插入了一个dom(a)元素。
        document.body.appendChild(link);
        // 创建一个a链接 使用a.click()模拟点击
        link.click();
        document.body.removeChild(link);
      });
      // let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      // let a = document.createElement("a");
      // a.style.display = "none";
      // console.log(API_HOST() +
      //     `/evaluationTargetRemote/newFileDownload?accessToken=${userInfo.accessToken}&userName=${props.rowInfo.userName}&schoolYear=${form.value.schoolYear}&schoolTerm=${form.value.schoolTerm}&schoolNum=${props.rowInfo.schoolNum}&classCode=${props.rowInfo.classCode}`)
      // a.href =
      //     API_HOST() +
      //     `/evaluationTargetRemote/newFileDownload?accessToken=${userInfo.accessToken}&userName=${props.rowInfo.userName}&schoolYear=${form.value.schoolYear}&schoolTerm=${form.value.schoolTerm}&schoolNum=${props.rowInfo.schoolNum}&classCode=${props.rowInfo.classCode}`;
      // a.click();
      // a = null;
    }
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [__props.rowInfo.sex === '男' ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[2] || (_cache[2] = [_createElementVNode("path", {
        d: "M512 105.3c-220.7 0-399.7 179-399.7 399.7s179 399.7 399.7 399.7 399.7-179 399.7-399.7-179-399.7-399.7-399.7z m241.6 270.8h-0.5v175.4h-99.8v-90.1l-46.6 49.7c13.7 27.1 21.4 57.6 21.4 90 0 110.4-89.5 200-199.9 200s-199.9-89.5-199.9-200 89.5-200 199.9-200c36.1 0 70.1 9.6 99.3 26.4l48.3-51.4h-97.5v-99.7h275.3v99.7z",
        fill: "#0091FF",
        "p-id": "9140"
      }, null, -1), _createElementVNode("path", {
        d: "M428 501.5c-55.1 0-99.7 44.8-99.7 100s44.6 100 99.7 100 99.7-44.8 99.7-100-44.7-100-99.7-100z",
        fill: "#0091FF",
        "p-id": "9141"
      }, null, -1)]))])) : (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[3] || (_cache[3] = [_createElementVNode("path", {
        d: "M512 105.5c-220.6 0-399.5 178.9-399.5 399.5S291.4 904.5 512 904.5 911.5 725.6 911.5 505 732.6 105.5 512 105.5z m200 621.9H561.5v75.1h-99.1v-75.1H312V627.3h150.4v-6.2c-33.6-8.6-65.5-25.9-91.8-52.2-78-78-78-204.5 0-282.5s204.5-78 282.5 0 78 204.5 0 282.5c-26.3 26.3-58.1 43.7-91.7 52.2v6.2h150.4v100.1h0.2z",
        fill: "#FF4D94",
        "p-id": "11153"
      }, null, -1), _createElementVNode("path", {
        d: "M582.4 356.1c-39.1-39.1-102.5-39.1-141.6 0-39.1 39.1-39.1 102.4 0 141.5 39.1 39.1 102.5 39.1 141.6 0 39.1-39 39.1-102.4 0-141.5z",
        fill: "#FF4D94",
        "p-id": "11154"
      }, null, -1)]))]))]), _createElementVNode("div", _hoisted_6, _toDisplayString(__props.rowInfo.studentName), 1)]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_form, {
        inline: true,
        model: _unref(form)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "学年"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(form).schoolYear,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form).schoolYear = $event),
            class: "m-2",
            placeholder: "请选择",
            onChange: changeschoolYear
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schoolYears), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "学期"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: _unref(form).schoolTerm,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(form).schoolTerm = $event),
            class: "m-2",
            placeholder: "请选择",
            onChange: changeschoolTerm
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(schoolTerms), item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            onClick: exportDoc
          }, {
            default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("导出", -1)]))]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("ul", null, [_createElementVNode("li", null, [_cache[10] || (_cache[10] = _createElementVNode("div", {
        class: "header-title",
        style: {
          "margin": "10px 0"
        }
      }, [_createElementVNode("span", null, "一、综合素养")], -1)), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_cache[9] || (_cache[9] = _createElementVNode("div", {
        class: "row1"
      }, [_createElementVNode("div", {
        class: "category"
      }, "类别"), _createElementVNode("div", {
        class: "project"
      }, "项目"), _createElementVNode("div", {
        class: "standard"
      }, "是否达标")], -1)), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ZHSY).newEvaluationList, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "row2",
          key: index
        }, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, _toDisplayString(item.targetName), 1), _cache[5] || (_cache[5] = _createElementVNode("div", {
          class: "row2-item1-pd2"
        }, null, -1)), _cache[6] || (_cache[6] = _createElementVNode("div", {
          class: "row2-item1-pd3"
        }, null, -1))]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.targetList, (item2, index2) => {
          return _openBlock(), _createElementBlock("div", {
            class: "row2-item2",
            key: index2
          }, [_createElementVNode("div", _hoisted_13, _toDisplayString(item2.targetName), 1), _createElementVNode("div", _hoisted_14, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item2.targetList, (item3, index3) => {
            return _openBlock(), _createElementBlock("div", {
              class: "xm-item",
              key: index3
            }, [_createElementVNode("div", {
              class: "xm-cont",
              style: _normalizeStyle({
                borderBottom: index3 + 1 === item2.targetList.length ? '0' : '1px solid rgba(64,158,255,.4)'
              })
            }, _toDisplayString(item3.targetName), 5), _createElementVNode("div", {
              class: "dabiao",
              style: _normalizeStyle({
                borderBottom: index3 + 1 === item2.targetList.length ? '0' : '1px solid rgba(64,158,255,.4)',
                color: item3.evaluationResult == '不达标' && 'red'
              })
            }, _toDisplayString(item3.evaluationResult), 5)]);
          }), 128))])]);
        }), 128))]);
      }), 128)), _createElementVNode("div", _hoisted_15, [_cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "category"
      }, null, -1)), _cache[8] || (_cache[8] = _createElementVNode("div", {
        class: "project"
      }, "总体评价等级", -1)), _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(ZHSY).evaluationLevel === "" ? "暂无" : _unref(ZHSY).evaluationLevel), 1)])])])]), _createElementVNode("li", null, [_cache[11] || (_cache[11] = _createElementVNode("div", {
        class: "header-title",
        style: {
          "margin": "10px 0"
        }
      }, [_createElementVNode("span", null, "二、学业水平")], -1)), _createVNode(_unref(ConfigTable), {
        ref: "configTable",
        "table-data": _unref(tableGrade),
        isBorder: true,
        rowClass: true
      }, null, 8, ["table-data"])]), _createElementVNode("li", null, [_cache[19] || (_cache[19] = _createElementVNode("div", {
        class: "header-title",
        style: {
          "margin": "10px 0"
        }
      }, [_createElementVNode("span", null, "三、身心健康")], -1)), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_cache[14] || (_cache[14] = _createElementVNode("span", {
        style: {
          "margin-left": "15px"
        }
      }, "身体素质", -1)), _createElementVNode("span", _hoisted_20, [_cache[12] || (_cache[12] = _createTextVNode("总分 ", -1)), _createElementVNode("span", null, _toDisplayString(_unref(SXJK).finalScore), 1)]), _createElementVNode("span", _hoisted_21, [_cache[13] || (_cache[13] = _createTextVNode("等级 ", -1)), _createElementVNode("span", null, _toDisplayString(_unref(SXJK).level), 1)])]), _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_cache[15] || (_cache[15] = _createElementVNode("span", null, "身高（厘米）：", -1)), _createElementVNode("span", null, _toDisplayString(_unref(SXJK).height), 1)]), _createElementVNode("div", _hoisted_24, [_cache[16] || (_cache[16] = _createElementVNode("span", null, "体重（千克）：", -1)), _createElementVNode("span", null, _toDisplayString(_unref(SXJK).weight), 1)]), _createElementVNode("div", _hoisted_25, [_cache[17] || (_cache[17] = _createElementVNode("span", null, "视力左：", -1)), _createElementVNode("span", {
        class: _normalizeClass({
          perfect: _unref(SXJK).rightVisionLevel == '正常' ? true : false,
          blue: _unref(SXJK).rightVisionLevel == '轻度视力低下' ? true : false,
          Munde: _unref(SXJK).rightVisionLevel == '中度视力低下' ? true : false,
          red: _unref(SXJK).rightVisionLevel == '重度视力低下' ? true : false
        })
      }, _toDisplayString(_unref(SXJK).leftVisionValue) + " " + _toDisplayString(_unref(SXJK).leftVisionLevel), 3)]), _createElementVNode("div", _hoisted_26, [_cache[18] || (_cache[18] = _createElementVNode("span", null, "视力右：", -1)), _createElementVNode("span", {
        class: _normalizeClass({
          perfect: _unref(SXJK).rightVisionLevel == '正常' ? true : false,
          blue: _unref(SXJK).rightVisionLevel == '轻度视力低下' ? true : false,
          Munde: _unref(SXJK).rightVisionLevel == '中度视力低下' ? true : false,
          red: _unref(SXJK).rightVisionLevel == '重度视力低下' ? true : false
        })
      }, _toDisplayString(_unref(SXJK).rightVisionValue) + " " + _toDisplayString(_unref(SXJK).rightVisionLevel), 3)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(SXJK).physicalCategoryScoreInfoVoList, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "row2-item",
          key: item.categoryName
        }, [item.categoryName ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(item.categoryName) + "：", 1)) : _createCommentVNode("", true), _createElementVNode("span", {
          class: _normalizeClass({
            perfect: item.levelCode == 1 ? true : false,
            green: item.levelCode == 2 ? true : false,
            blue: item.levelCode == 3 ? true : false,
            red: item.levelCode == 4 ? true : false
          })
        }, _toDisplayString(item.value) + " " + _toDisplayString(item.level), 3)]);
      }), 128))])])])]), _createElementVNode("li", null, [_cache[21] || (_cache[21] = _createElementVNode("div", {
        class: "header-title",
        style: {
          "margin": "10px 0"
        }
      }, [_createElementVNode("span", null, "四、学生荣誉")], -1)), _createElementVNode("div", _hoisted_28, [_createElementVNode("div", _hoisted_29, [_cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "row1"
      }, [_createElementVNode("div", {
        class: "row1-item"
      }, "荣誉称号"), _createElementVNode("div", {
        class: "row1-item"
      }, "获取日期"), _createElementVNode("div", {
        class: "row1-item"
      }, "颁发机构")], -1)), _createElementVNode("div", _hoisted_30, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(XSRY), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "row2-item",
          key: index
        }, [_createElementVNode("div", _hoisted_31, _toDisplayString(item.rewardName), 1), _createElementVNode("div", _hoisted_32, _toDisplayString(item.rewardDate), 1), _createElementVNode("div", _hoisted_33, _toDisplayString(item.rewardUnit), 1)]);
      }), 128))])])])]), _createElementVNode("li", null, [_cache[22] || (_cache[22] = _createElementVNode("div", {
        class: "header-title",
        style: {
          "margin": "10px 0"
        }
      }, [_createElementVNode("span", null, "五、教师寄语")], -1)), _createElementVNode("div", _hoisted_34, [_createElementVNode("div", _hoisted_35, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(JSJY), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: _normalizeClass([index % 2 === 0 ? 'row1 row1Bgc' : 'row1']),
          key: item.commentName
        }, [_createElementVNode("div", _hoisted_36, _toDisplayString(item.commentName), 1), _createElementVNode("div", _hoisted_37, _toDisplayString(item.commentText), 1)], 2);
      }), 128))])])])])])]);
    };
  }
};